import React from 'react';
import * as DateUtils from 'utils/dates';
import ActionsBlock from './ActionsBlock';
import * as CurrencyUtils from 'utils/currency';

const CONFIGURATION = {};

export default CONFIGURATION;

export const TableColumns = [
  {
    label: '#',
    id: 'vat_return_received_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'VAT Number',
    id: 'vat_number',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'MSID Country',
    id: 'country_code',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Scheme Type',
    id: 'application_type',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'VAT Return Type',
  //   id: 'vat_return_type',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'VAT Return Reference',
    id: 'vat_return_reference',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Year',
    id: 'year',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Period',
    id: 'quarter',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'Version',
  //   id: 'version',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Submission Date',
    id: 'submission_date',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{DateUtils.formatDate(cellValue)}</React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'Change Date',
  //   id: 'change_date',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'VAT Amount',
    id: 'grand_total',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        €{CurrencyUtils.formatCurrency(cellValue)}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Payable Amount',
    id: 'balance_of_vat_value',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        €{CurrencyUtils.formatCurrency(cellValue)}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Amount Received',
    id: 'amount_received',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            color:
              data[rowIndex].balance_of_vat_value > cellValue
                ? 'red'
                : data[rowIndex].balance_of_vat_value < cellValue
                ? 'orange'
                : 'black',
            fontWeight:
              data[rowIndex].balance_of_vat_value === cellValue
                ? 'normal'
                : 'bold',
          }}
        >
          €{CurrencyUtils.formatCurrency(cellValue)}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Actions',
    align: 'center',
    id: 'action1',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <ActionsBlock
        rowIndex={rowIndex}
        vat_return_received_id={data[rowIndex].vat_return_received_id}
        error={data[rowIndex].error}
        incoming_message_id={data[rowIndex].incoming_message_id}
        vat_return_reference={data[rowIndex].vat_return_reference}
        total_msid_services={data[rowIndex].total_msid_services}
        total_msid_goods={data[rowIndex].total_msid_goods}
        total_msest_services={data[rowIndex].total_msest_services}
        total_msest_goods={data[rowIndex].total_msest_goods}
        total_corrections={data[rowIndex].total_corrections}
        grand_total={data[rowIndex].grand_total}
        balance_of_vat_value={data[rowIndex].balance_of_vat_value}
        total_amount_to_be_reimbursed={data[rowIndex].amount_to_be_reimbursed}
        total_amount_reimbursed={data[rowIndex].amount_reimbursed}
        version={data[rowIndex].version}
        change_date={data[rowIndex].change_date}
      />
    ),
    inData: false,
  },
];

interface ITableDefaultFetchValues {
  TABLE_DEFAULT_PAGE: number;
  TABLE_DEFAULT_PAGE_SIZE: number;
  TABLE_DEFAULT_ORDER: 'desc' | 'asc';
  TABLE_DEFAULT_SORT_KEY: string;
}

export const VatReturnsReceivedTableDefaultFetchValues: ITableDefaultFetchValues =
  {
    TABLE_DEFAULT_PAGE: 0,
    TABLE_DEFAULT_PAGE_SIZE: 25,
    TABLE_DEFAULT_ORDER: 'desc',
    TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
  };
